export enum ATeamHcpStatus {
  A_TEAM = "A_TEAM",
}

export type ATeamWorkplaces = Record<
  string,
  {
    name: string;
    id: string;
    workerTypes: string[];
    recentUpdatedAt?: Date;
    aTeamRosterSize?: number;
  }
>;
